function isPlainObject(value) {
  return Object.prototype.toString.call(value) === '[object Object]';
}

export function deepMerge(base, override) {
  if (!isPlainObject(base) || !isPlainObject(override)) {
    return override === undefined ? base : override;
  }

  const merged = { ...base };

  Object.keys(override).forEach((key) => {
    const baseValue = base[key];
    const overrideValue = override[key];

    if (isPlainObject(baseValue) && isPlainObject(overrideValue)) {
      merged[key] = deepMerge(baseValue, overrideValue);
      return;
    }

    merged[key] = overrideValue;
  });

  return merged;
}
